module.exports = __webpack_public_path__ + "static/media/portal-enter.ee358b4f.svg";